import { render, staticRenderFns } from "./PrformanceAdmin.vue?vue&type=template&id=56233dcd&scoped=true"
import script from "./PrformanceAdmin.vue?vue&type=script&lang=js"
export * from "./PrformanceAdmin.vue?vue&type=script&lang=js"
import style0 from "./PrformanceAdmin.vue?vue&type=style&index=0&id=56233dcd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56233dcd",
  null
  
)

export default component.exports